/* ============================================================
   Meidi Pricing v2 - motorul de pret al paginii de produs.

   SINGURA sursa de adevar pentru: varianta selectata, cantitatea,
   optiunea "cu logo", treapta taxei de logo si taxa de stanta.

   UI-ul (tabelul de cantitati, cardul LOGO, pretul din capul paginii)
   doar CITESTE de aici si se aboneaza la schimbari. Dependintele merg
   intr-o singura directie:  config -> motor -> UI.

   Config:  window.MeidiPricingConfig  (snippets/meidi-pricing-config.liquid)
   Acces:   window.MeidiPricingReady(function (P) { ... })

   v2 - taxa de logo nu mai e fixa, ci pe TREPTE dupa cantitate.
   Treptele vin din variantele produsului "taxa-personalizare-logo"
   (vezi snippets/meidi-fee-tiers.liquid). Aici nu e hardcodat niciun pret.

   v2.1 - COMANDA MINIMA CU LOGO: cu personalizarea pornita, cantitatea nu
   poate cobori sub pragul din config (implicit 100 buc.), ridicat la primul
   multiplu de MOQ. Vezi LOGO_MIN_QTY mai jos.

   COSUL NU ESTE ATINS AICI. Taxele intra in cos prin assets/meidi-logo-fees.js,
   pe baza proprietatii "Logo personalizat" de pe linia de produs.
   ============================================================ */
(function () {
  'use strict';

  if (window.MeidiPricing) return;

  var CFG = window.MeidiPricingConfig;
  if (!CFG) return;

  /* ---------- Pragurile Dealeasy ----------
     Oglindesc EXACT configuratia din aplicatia Dealeasy, care aplica discountul
     pe TAG-uri (appliesTo: TAGS, selectedTags: ["moq-48", ...]).
     Cheia hartii = valoarea din tagul moq-N al produsului.
     Daca schimbi reducerile in Dealeasy, actualizeaza harta de mai jos. */
  var DL = {};
  function reg(keys, tiers) { for (var i = 0; i < keys.length; i++) DL[keys[i]] = tiers; }

  reg([1, 2],                                  [[50,3],[100,7],[200,10],[500,15],[1000,20],[2000,30]]);
  reg([3],                                     [[20,3],[80,7],[120,10],[220,15],[600,20],[1000,30]]);
  reg([4, 5],                                  [[40,3],[120,7],[200,10],[480,15],[680,20],[1000,30]]);
  reg([6, 7],                                  [[60,3],[180,7],[300,10],[900,15],[1500,20],[3000,30]]);
  reg([8, 9],                                  [[80,3],[240,7],[400,10],[1200,15],[2000,20],[4000,30]]);
  reg([10],                                    [[100,3],[300,7],[500,10],[1500,15],[2500,20],[5000,30]]);
  reg([12, 13],                                [[120,3],[360,7],[600,10],[1800,15],[3000,20],[6000,30]]);
  reg([15],                                    [[150,3],[450,7],[750,10],[2250,15],[3750,20],[7500,30]]);
  reg([16, 17],                                [[160,3],[480,7],[800,10],[2400,15],[4000,20],[8000,30]]);
  reg([18, 19],                                [[180,3],[540,7],[900,10],[2700,15],[4500,20],[9000,30]]);
  reg([20, 22],                                [[200,3],[600,7],[1000,10],[3000,15],[5000,20],[10000,30]]);
  reg([23, 24],                                [[240,3],[720,7],[1200,10],[3600,15],[6000,20],[12000,30]]);
  reg([25, 26, 27],                            [[250,3],[750,7],[1250,10],[3750,15],[6250,20],[12500,30]]);
  reg([29, 30],                                [[300,3],[900,7],[1500,10],[4500,15],[7500,20],[15000,30]]);
  reg([37, 39, 40, 41, 42, 43],                [[400,3],[1200,7],[2000,10],[6000,15],[10000,20],[20000,30]]);
  reg([46, 48, 49],                            [[480,3],[1440,7],[2400,10],[7200,15],[12000,20],[24000,30]]);
  reg([50],                                    [[500,3],[1500,7],[2500,10],[7500,15],[12500,20],[25000,30]]);
  reg([56, 58, 60, 65, 78, 80],                [[600,3],[1800,7],[3000,10],[9000,15],[15000,20],[30000,30]]);
  reg([82, 84, 85, 89, 90, 93, 94, 97, 98, 100, 107],  [[1000,3],[3000,7],[5000,10],[15000,15],[25000,20],[50000,30]]);
  reg([115, 120, 128, 133, 160, 161, 163, 167],        [[1200,3],[3600,7],[6000,10],[18000,15],[30000,20],[60000,30]]);
  reg([180, 184, 200, 320, 374, 400, 500, 535],        [[2000,3],[6000,7],[10000,10],[30000,15],[50000,20],[100000,30]]);

  /* Randul de baza + pragurile peste MOQ. Fara configuratie Dealeasy pentru acest
     MOQ ramane doar randul de baza: nu promitem reduceri care nu se aplica la checkout. */
  var TIERS = [{ qty: CFG.moq, disc: 0 }];
  (function () {
    var t = DL[CFG.moqTag];
    if (!t) return;
    for (var i = 0; i < t.length; i++) {
      if (t[i][0] > CFG.moq) TIERS.push({ qty: t[i][0], disc: t[i][1] });
    }
  })();

  /* ---------- Treptele taxei de logo ----------
     Vin din Shopify (o varianta per treapta), NU sunt scrise aici.
     Pragurile sunt absolute - se raporteaza la bucatile comandate, nu la MOQ. */
  var FEE_TIERS = (function () {
    var raw = (CFG.fees && CFG.fees.tiers) || [];
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var t = raw[i];
      var min = parseInt(t.minQty, 10);
      var price = parseInt(t.price, 10);
      if (!isNaN(min) && min > 0 && !isNaN(price) && price >= 0) {
        out.push({ minQty: min, price: price, variantId: t.variantId });
      }
    }
    out.sort(function (a, b) { return a.minQty - b.minQty; });
    return out;
  })();

  /* Treapta aplicabila pentru o cantitate. Sub prima treapta ramane prima treapta
     (cea mai scumpa) - niciodata "gratis" dintr-o scapare de configurare. */
  function feeFor(qty) {
    if (!FEE_TIERS.length) return null;
    var t = FEE_TIERS[0];
    for (var i = 0; i < FEE_TIERS.length; i++) {
      if (FEE_TIERS[i].minQty <= qty) t = FEE_TIERS[i];
    }
    return t;
  }

  /* ---------- Comanda minima cu logo ----------
     Cu personalizarea pornita, cantitatea minima nu mai e MOQ-ul, ci pragul
     din config (CFG.logoMinQty, setare in sectiunea Tabel Cantitate, implicit
     100). Pragul se ridica la primul MULTIPLU de MOQ: produsele se vand in
     baxuri, nu poti da 100 din ceva ambalat cate 48 - se face 144.
     Daca pragul nu depaseste MOQ-ul (MOQ 100, 200...), nu schimba nimic.
     0 in setare = regula dezactivata. Produs fara logo (fees null) = 0. */
  var LOGO_MIN_QTY = (function () {
    var want = parseInt(CFG.logoMinQty, 10);
    if (!CFG.fees || isNaN(want) || want <= 0) return 0;
    var m = CFG.moq > 0 ? CFG.moq : 1;
    var q = Math.ceil(want / m) * m;
    return q > m ? q : 0;
  })();

  /* ---------- starea ---------- */
  var state = {
    variantId: CFG.currentVariantId,
    qty: CFG.moq,
    logo: false,       /* clientul vrea personalizare cu logo */
    logoFile: false,   /* fisierul de logo a fost incarcat cu succes */
    hasStanta: false   /* clientul declara ca are deja stanta la Meidi */
  };

  var subs = [];

  /* ---------- calcule ---------- */

  function basePrice() {
    var p = CFG.variantPrices || {};
    var v = state.variantId;
    if (v !== null && v !== undefined && p[v] !== undefined) return p[v];
    for (var k in p) { if (Object.prototype.hasOwnProperty.call(p, k)) return p[k]; }
    return 0;
  }

  function tierFor(qty) {
    var t = TIERS[0];
    for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].qty <= qty) t = TIERS[i]; }
    return t;
  }

  /* Rotunjire IDENTICA cu Shopify/Dealeasy la checkout: reducerea in bani este
     TRUNCHIATA (floor), nu rotunjita. Confirmat cu draftOrderCalculate. */
  function cut(amount, disc) { return amount - Math.floor(amount * disc / 100); }

  /* Taxa de logo si stanta NU primesc reducere de volum: discountul Dealeasy
     tinteste tag-urile moq-N, iar produsele-taxa au doar tagul "taxa-personalizare".
     Deci: pret/buc cu logo = (pret produs REDUS) + taxa treptei, nu (pret + taxa) redus.
     Taxa scade oricum singura, prin treptele ei. */
  function quote(qty, opt) {
    opt = opt || {};
    var logo      = opt.logo      !== undefined ? opt.logo      : state.logo;
    var hasStanta = opt.hasStanta !== undefined ? opt.hasStanta : state.hasStanta;
    var f = CFG.fees;

    var base = basePrice();
    var disc = tierFor(qty).disc;

    var unitNet  = cut(base, disc);
    var feeTier  = (logo && f) ? feeFor(qty) : null;
    var fee      = feeTier ? feeTier.price : 0;
    var stanta   = (logo && f && !hasStanta) ? f.stantaPrice : 0;

    /* Discountul Dealeasy e alocat PE BUCATA (allocation_method: "each"):
       Shopify trunchiaza reducerea la nivel de bucata si abia apoi inmulteste.
       Verificat pe un cos real: 480 x 7,99 cu -3% => 480 x 7,76 = 3.724,80 lei,
       nu 3.720,15 cat ar da trunchierea aplicata pe totalul liniei. */
    var productTotal = unitNet * qty;
    var feeTotal = fee * qty;

    return {
      qty: qty,
      disc: disc,
      logo: logo,
      logoFile: state.logoFile,
      hasStanta: hasStanta,
      feesAvailable: !!f,
      unitBase: base,        /* pret/buc de lista */
      unitNet: unitNet,      /* pret/buc dupa reducerea de volum */
      fee: fee,              /* taxa logo/buc pe treapta curenta (0 daca fara logo) */
      feeVariantId: feeTier ? feeTier.variantId : 0,
      unit: unitNet + fee,   /* pret/buc afisat clientului */
      productTotal: productTotal,
      feeTotal: feeTotal,
      stanta: stanta,
      total: productTotal + feeTotal + stanta
    };
  }

  /* ---------- formatare ---------- */

  function money(cents) {
    var f = CFG.moneyFormat || '';
    var cur = f.replace(/\{\{[^}]+\}\}/g, '').trim();
    var s = (cents / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var n = s[0] + ',' + s[1];
    if (!cur) return n;
    return f.indexOf('{' + '{') === 0 ? n + ' ' + cur : cur + ' ' + n;
  }

  function int(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  /* ---------- mutatii de stare ---------- */

  /* Pragul de jos depinde de stare: MOQ fara logo, LOGO_MIN_QTY cu logo.
     Pasul ramane MOQ-ul in ambele cazuri. */
  function snapQty(v) {
    var m = CFG.moq;
    var floor = (state.logo && LOGO_MIN_QTY) ? LOGO_MIN_QTY : m;
    v = parseInt(v, 10);
    if (isNaN(v) || v < floor) return floor;
    var s = Math.round(v / m) * m;
    return s < floor ? floor : s;
  }

  function emit() {
    var q = quote(state.qty);
    for (var i = 0; i < subs.length; i++) {
      try { subs[i](q, state); } catch (e) { console.error('[Meidi Pricing] abonat:', e); }
    }
  }

  function set(patch) {
    var changed = false;
    for (var k in patch) {
      if (Object.prototype.hasOwnProperty.call(patch, k) && state[k] !== patch[k]) {
        state[k] = patch[k];
        changed = true;
      }
    }
    if (changed) emit();
    return changed;
  }

  var API = {
    config: CFG,
    tiers: TIERS,
    feeTiers: FEE_TIERS,
    feeFor: feeFor,
    logoMinQty: LOGO_MIN_QTY,
    state: state,
    money: money,
    int: int,
    quote: quote,
    snapQty: snapQty,
    current: function () { return quote(state.qty); },
    setQty:      function (v) { return set({ qty: snapQty(v) }); },
    setVariant:  function (id) { return set({ variantId: id }); },
    /* Pornirea logo-ului sub prag urca automat cantitatea la prag, in aceeasi
       emisie - clientul nu vede nicio clipa preturi cu logo la o cantitate
       pe care oricum n-am accepta-o. Oprirea nu coboara nimic. */
    setLogo: function (v) {
      v = !!v;
      var patch = { logo: v };
      if (v && LOGO_MIN_QTY && state.qty < LOGO_MIN_QTY) patch.qty = LOGO_MIN_QTY;
      return set(patch);
    },
    setLogoFile: function (v) { return set({ logoFile: !!v }); },
    setStanta:   function (v) { return set({ hasStanta: !!v }); },
    subscribe: function (fn) {
      subs.push(fn);
      try { fn(quote(state.qty), state); } catch (e) { console.error('[Meidi Pricing] abonat:', e); }
      return function () { var i = subs.indexOf(fn); if (i > -1) subs.splice(i, 1); };
    }
  };

  window.MeidiPricing = API;

  /* ---------- puntea catre formularul de produs (doar cantitatea) ---------- */

  var wantedQty = state.qty;
  var qtyRetry = null;

  function writeQty() {
    var form = document.querySelector('[data-product-form]') ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form) {
      if (!qtyRetry) qtyRetry = setTimeout(function () { qtyRetry = null; writeQty(); }, 200);
      return;
    }
    var input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }
    if (String(input.value) !== String(wantedQty)) input.value = wantedQty;
  }

  API.subscribe(function (q) { wantedQty = q.qty; writeQty(); });

  /* compatibilitate cu apelurile mai vechi */
  window._meidiSetQty = function (qty) { API.setQty(qty); };

  /* ---------- schimbarea variantei ---------- */

  document.addEventListener('theme:variant:changed', function (e) {
    var v = e.detail && (e.detail.variant || e.detail.selectedVariant);
    if (v && v.id) API.setVariant(v.id);
  });

  /* ---------- eliberarea cozii ---------- */

  var queue = window.__meidiPricingQueue || [];
  window.__meidiPricingQueue = [];
  window.MeidiPricingReady = function (fn) {
    try { fn(API); } catch (e) { console.error('[Meidi Pricing] init:', e); }
  };
  for (var qi = 0; qi < queue.length; qi++) window.MeidiPricingReady(queue[qi]);
})();